/**
 * TimelineIcon — 타임라인(DISPATCHER) 모듈 커스텀 아이콘
 *
 * 납작한 직사각형 프레임 + 헤더 구분선 + 눈금 + 빨간 now indicator.
 */

interface TimelineIconProps {
  className?: string;
}

export function TimelineIcon({ className = "w-5 h-5" }: TimelineIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* 납작한 프레임 */}
      <rect x="1" y="3" width="22" height="19" rx="2.5" stroke="currentColor" strokeWidth="2" />

      {/* 헤더 구분선 */}
      <line x1="1" y1="9" x2="23" y2="9" stroke="currentColor" strokeWidth="2" />

      {/* 헤더 눈금 틱 */}
      <line x1="6" y1="4.5" x2="6" y2="7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <line x1="18" y1="4.5" x2="18" y2="7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />

      {/* 빨간 현재시간: 역삼각형 ▼ + 세로선 */}
      <path d="M10.5 5.5 L12 8.5 L13.5 5.5 Z" fill="#ef4444" />
      <line x1="12" y1="7" x2="12" y2="21.5" stroke="#ef4444" strokeWidth="2" />
    </svg>
  );
}
